import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Grid, Field } from 'nallian-shared-ui/lib/components';
import { useTranslation } from 'react-i18next';
import {
  InputFieldValueComponent,
  SelectFieldValueComponent,
} from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import { FormModal } from 'nallian-shared-ui/lib/modules';
import { generateErrorsForRequiredFields } from '../../../app/lib/validationHelper';
import organisationRolesService from '../../../organisationRoles/services/organisationRolesService';
import ReadOnlyFieldValueComponent from '../../../app/components/ReadOnlyFieldValueComponent';

const FORM_NAME = 'communityRole';
const REQUIRED_FIELDS = ['organisationRole'];

const validate = values => {
  let errors = {};
  errors = generateErrorsForRequiredFields(REQUIRED_FIELDS, values, errors);

  return errors;
};

const CommunityRoleForm = ({
  dispatchOrganisationRolesGet,
  organisationRolesFetch,
  submitProcessing,
  dataLoading,
  data,
  returnRoute,
  onSubmit,
  header,
  editMode,
}) => {
  const { t } = useTranslation();

  useEffect(() => dispatchOrganisationRolesGet(undefined, t), [dispatchOrganisationRolesGet, t]);

  const roleOptions = useMemo(
    () =>
      (organisationRolesFetch.value?.organisationRoles || []).map(r => ({
        key: r.tag,
        value: r.tag,
        text: r.name,
      })),
    [organisationRolesFetch.value]
  );

  return (
    <FormModal
      closeIcon
      header={header}
      dataLoading={dataLoading}
      submitProcessing={submitProcessing}
      onSubmit={onSubmit}
      data={data}
      t={t}
      validate={validate}
      form={FORM_NAME}
      cancelRoute={returnRoute}
      cancelButtonContent={t('cancel')}
      saveButtonIcon="save"
      saveButtonContent={t('save')}
    >
      <Grid>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            search
            clearable
            fluid
            label={t('organisationRole')}
            name="tag"
            valueComponent={editMode ? ReadOnlyFieldValueComponent : SelectFieldValueComponent}
            options={roleOptions}
            disabled={submitProcessing || dataLoading}
          />
        </Grid.Column>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            fluid
            label={t('alias')}
            name="alias"
            valueComponent={InputFieldValueComponent}
            disabled={submitProcessing || dataLoading}
          />
        </Grid.Column>
      </Grid>
    </FormModal>
  );
};

CommunityRoleForm.propTypes = {
  dispatchOrganisationRolesGet: PropTypes.func.isRequired,
  organisationRolesFetch: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  dataLoading: PropTypes.bool,
  submitProcessing: PropTypes.bool,
  header: PropTypes.string.isRequired,
  returnRoute: PropTypes.string.isRequired,
  data: PropTypes.object,
  editMode: PropTypes.bool,
};

CommunityRoleForm.defaultProps = {
  dataLoading: false,
  editMode: false,
  submitProcessing: false,
  data: {},
};

export default organisationRolesService(CommunityRoleForm);
